import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappNumber = '919663306819';
  const message = encodeURIComponent('Hi! I\'m interested in learning about stock market trading.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 md:bottom-[56px] right-4 md:right-8 z-40 w-12 h-12 md:w-14 md:h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 group data-[menu-open=true]:hidden md:data-[menu-open=true]:flex"
      data-menu-open={document.body.getAttribute('data-menu-open') === 'true'}
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-5 h-5 md:w-7 md:h-7 text-white" fill="white" />

      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-2 bg-foreground text-background text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        Chat with us
      </span>

      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25"></span>
    </a>
  );
};

export default WhatsAppButton;
